<template>
  <home-layout :is-loading="isLoading" :data-loaded="dataLoaded" :error="error" :mode="mode">
    <DonateView v-if="mode === 'form' && dataLoaded" />
    <home-confirmation v-if="mode === 'confirmation'" />
    <v-alert v-if="mode === 'erreur'" type="error" text border="left">
      Une erreur est survenue lors du paiement. Veuillez vous assurer que le montant du don est supérieur à 10$ et que le code postal indiqué
      correspond à celui de votre carte de crédit.
    </v-alert>
  </home-layout>
</template>

<script>
import DonateView from "@/components/DonateView"
import HomeConfirmation from "@/components/HomeConfirmation"
import { mapActions } from "vuex"
import HomeLayout from "@/components/HomeLayout"
import { EventBus } from "@/main.js"

export default {
  name: "HomeView",
  metaInfo() {
    return {
      titleTemplate: "Fondation de l'Université de Sherbrooke - %s",
      meta: [
        {
          property: "og:url",
          content: window.location.href,
          vmid: "og:url"
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type"
        }
      ]
    }
  },
  components: {
    DonateView,
    HomeConfirmation,
    HomeLayout
  },
  data() {
    return {
      mode: "form", // ou form ou confirmation ou erreur
      params: undefined,
      isLoading: false,
      dataLoaded: false,
      error: ""
    }
  },
  computed: {
    campaignSlug() {
      return this.$route.params.campaign_slug
    }
  },
  created() {
    EventBus.$on("change-mode", this.changeMode)
    EventBus.$on("set-is-loading", this.setIsLoading)
  },
  mounted() {
    this.isLoading = true
    this.setCampaignSlug(this.campaignSlug)
    this.setCurrentURL(window.location.href)

    this.$axios.api.get(`traductions`).then((response) => {
      this.setTraductions(response.data)
    })

    this.$axios.api
      .get(`form/${this.campaignSlug}`)
      .then((response) => {
        this.setParamsMultilingue(response.data)
        const langues = response.data.map((p) => p.formParams.language)
        this.setLangues(langues)

        const defaultModele = response.data.find((p) => p.default)
        const defaultLang = defaultModele.formParams.language.name
        let langue = defaultLang
        let localStorageLang = localStorage.getItem("Langue_Formulaire_Don_FUS_SRDD")

        if (localStorageLang && langues.map((l) => l.name).includes(localStorageLang)) {
          langue = localStorageLang
        }
        this.setCurrentLang(langue)
        const params = response.data.find((p) => p.formParams.language.name === langue)

        this.setParams(params)

        this.$vuetify.theme.themes.light.primary = params.formParams.themeColor
        this.isLoading = false
        this.dataLoaded = true
      })
      .catch((error) => {
        console.log(error)
        this.error = this.toErrorMessage(error)
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions([
      "setParams",
      "setCampaignSlug",
      "setCurrentURL",
      "setLangues",
      "setCurrentLang",
      "setParamsMultilingue",
      "setConstantes",
      "setTraductions"
    ]),
    toErrorMessage(code) {
      return "Le formulaire est introuvable"
    },
    changeMode(mode) {
      this.mode = mode
    },
    setIsLoading(isLoading) {
      this.isLoading = isLoading
    }
  }
}
</script>

<style scoped>
</style>
